import 'bootstrap';
import './admin.scss';

import './images/gutenslider_start_image.svg';
import './images/gutenslider_icon.svg';
import './images/adding-gutenslider-block-1600x849.png';
import './images/samuel-zeller-158996-unsplash.png';
import './images/gutenslider_logo-300x300.png';
